export default function ({ $axios, store, $sentry }) {
  $axios.setBaseURL(process.env.BASE_API)
  $axios.setHeader('DeviceType', 'web')
  $axios.onRequest((config) => {
    if (store.state.token) {
      config.headers.common.Authorization = `Bearer ${store.state.token}`
    }
  })
  $axios.onError((error) => {
    $sentry.captureException(error)
    if (error.response.status === 401) {
      window.location.href = process.env.LOGIN_URL
    } else {
      throw error.response
    }
  })
}
